var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOther(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5,21H4.5c-1.93,0-3.5-1.57-3.5-3.5V4.5c0-1.93,1.57-3.5,3.5-3.5h6.5v3.5c0,1.38,1.12,2.5,2.5,2.5h3.5v1.5c0,.28,.22,.5,.5,.5s.5-.22,.5-.5c0,0,.01-2.1,0-2.14-.09-.79-.46-1.53-1.03-2.09l-3.24-3.24c-.65-.65-1.55-1.03-2.47-1.03H4.5C2.02,0,0,2.02,0,4.5v13c0,2.48,2.02,4.5,4.5,4.5h5c.28,0,.5-.22,.5-.5s-.22-.5-.5-.5ZM16.27,4.97c.29,.29,.5,.64,.62,1.03h-3.39c-.83,0-1.5-.67-1.5-1.5V1.11c.38,.12,.74,.33,1.03,.62l3.24,3.24Zm1.23,6.03c-3.58,0-6.5,2.92-6.5,6.5s2.92,6.5,6.5,6.5,6.5-2.92,6.5-6.5-2.92-6.5-6.5-6.5Zm0,12c-3.03,0-5.5-2.47-5.5-5.5s2.47-5.5,5.5-5.5,5.5,2.47,5.5,5.5-2.47,5.5-5.5,5.5Zm1-8c0,.55-.45,1-1,1s-1-.45-1-1,.45-1,1-1,1,.45,1,1Zm-.5,2.5v3c0,.28-.22,.5-.5,.5s-.5-.22-.5-.5v-3c0-.28,.22-.5,.5-.5s.5,.22,.5,.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOther);
export default __webpack_public_path__ + "static/media/Other.6f8f3ac027f4bcc6eee9e3a19add7fcb.svg";
export { ForwardRef as ReactComponent };